import { types, SnapshotIn, SnapshotOut } from 'mobx-state-tree'

export const StatisticsModel = types.model('Statistics', {
  unpaid_invoices: types.number,
  active_orders: types.number,
})

export type Statistics = SnapshotIn<typeof StatisticsModel>
export type StatisticsSnapshot = SnapshotOut<typeof StatisticsModel>
